// src/components/UserProfile.js
import React,{useState, useEffect } from 'react';
import { Row, Col, Card, ListGroup, Badge } from 'react-bootstrap';

const DashboardCard = ({ title, links, leadsData , usersData , empData, ticketData, taskData  }) => (
  <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
    <Card style={{ width: '100%' }}>
      <Card.Header className="bg-primary text-white text-center">
        <Card.Title>{title}</Card.Title>
      </Card.Header>
      <Card.Body>
        <ListGroup variant="flush">
          {links.map((link, index) => (
            <ListGroup.Item key={index}>
              <Card.Link href={link.href}>{link.label}</Card.Link>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
      {title === 'Leads' && ( 
        <Card.Footer className="text-center">
          {leadsData &&  (
            <div>
              <div>Total : <Badge pill bg="info">{leadsData.total_leads}</Badge></div>
              <div>Open : <Badge pill bg="success">{leadsData.open_leads}</Badge> || converted: <Badge pill bg="danger">{leadsData.converted}</Badge></div>
              <div></div>
            </div>
          )}
        </Card.Footer>
      )}
      {title === 'Users' && ( 
        <Card.Footer className="text-center">
          {usersData  &&  (
            <div>
              <div>Total : <Badge pill bg="info">{usersData.TotalUsers}</Badge></div>
              <div></div>
            </div>
          )}
        </Card.Footer>
      )}
      {title === 'Managers' && ( 
        <Card.Footer className="text-center">
          {empData  &&  (
            <div>
              <div>Managers : <Badge pill bg="info">{empData.total_mgr}</Badge></div>
              <div>Sales Managers : <Badge pill bg="info">{empData.total_smgr}</Badge></div>
            </div>
          )}
        </Card.Footer>
      )}
      {title === 'Employees' && ( 
        <Card.Footer className="text-center">
          {empData  &&  (
            <div>
              <div>Employee : <Badge pill bg="info">{empData.total_emp}</Badge></div>
              <div></div>
            </div>
          )}
        </Card.Footer>
      )}
      {title === 'Tickets / Transactions' && ( 
        <Card.Footer className="text-center">
          {ticketData  &&  (
            <div>
              <div>Total : <Badge pill bg="info">{ticketData.total_tickets}</Badge></div>
              <div>Open : <Badge pill bg="success">{ticketData.open_tickets}</Badge> || Closed: <Badge pill bg="danger">{ticketData.closed_ticket}</Badge></div>
            </div>
          )}
        </Card.Footer>
      )}
      {title === 'Tasks' && ( 
        <Card.Footer className="text-center">
          {taskData  &&  (
            <div>
              <div>Total : <Badge pill bg="info">{taskData.total_tasks}</Badge></div>
              <div>Open : <Badge pill bg="success">{taskData.open_tasks}</Badge> || Closed: <Badge pill bg="danger">{taskData.closed_task}</Badge></div>
            </div>
          )}
        </Card.Footer>
      )}
    </Card>
  </Col>
);

const Dashboard = () => {
  const [leadsData, setLeadsData] = useState(null);
  const [usersData, setUsersData] = useState(null);
  const [empData, setEmpData] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const [taskData, setTaskData] = useState(null);

  useEffect(() => {
    // Fetch the leads data from the API
    fetch('https://apiaksharaconnect.aksharafinalytics.in/Dleads')
      .then((response) => response.json())
      .then((data) => setLeadsData(data))
      .catch((error) => console.error('Error fetching leads data:', error));
  }, []);

  // Fetch the users data from the API
  useEffect(() => {
    fetch('https://apiaksharaconnect.aksharafinalytics.in/DUsers')
      .then((response) => response.json())
      .then((data) => setUsersData(data))
      .catch((error) => console.error('Error fetching users data:', error));
  }, []);

  useEffect(() => {
    fetch('  https://apiaksharaconnect.aksharafinalytics.in/DEmployee')
      .then((response) => response.json())
      .then((data) => setEmpData(data))
      .catch((error) => console.error('Error fetching users data:', error));
  }, []);

  useEffect(() => {
    fetch('  https://apiaksharaconnect.aksharafinalytics.in/DTickets')
      .then((response) => response.json())
      .then((data) => setTicketData(data))
      .catch((error) => console.error('Error fetching users data:', error));
  }, []);

  useEffect(() => {
    fetch('  https://apiaksharaconnect.aksharafinalytics.in/DTasks')
      .then((response) => response.json())
      .then((data) => setTaskData(data))
      .catch((error) => console.error('Error fetching users data:', error));
  }, []);



  const cards = [
    {
      title: 'Leads',
      links: [
        { href: '/Lead', label: 'Add Leads' },
        { href: '/Leadlist', label: 'All Leads' }
      ]
    },
    {
      title: 'Users',
      links: [
        { href: '/User', label: 'Add Users' },
        { href: '/Userlist', label: 'All Users' }
      ]
    },
    {
      title: 'Managers',
      links: [
        { href: '/Manager', label: 'Add Manager' },
        { href: '/mlist', label: 'All Managers' }
      ]
    },
    {
      title: 'Employees',
      links: [
        { href: '/Employee', label: 'Add Employee' },
        { href: '/Employeelist', label: 'All Employees' }
      ]
    },
    {
      title: 'Messages',
      links: [
        { href: '/GreetingSms', label: 'Greeting SMS' },
        { href: '/GST', label: 'GST' }
      ]
    },
    {
      title: 'Wati Messages',
      links: [
        { href: '/WatiGreetings', label: 'Greetings' },
        { href: '/WatiGST', label: 'GST' }
      ]
    },
    {
      title: 'Tickets / Transactions',
      links: [
        { href: '/AllTickets', label: 'Tickets' },
        { href: '/payment', label: 'Transactions' }
      ]
    },
    {
      title: 'Tasks',
      links: [
        { href: '/Assignedtasks', label: 'Tasks' }
      ]
    }
  ];

  return (
    <Row className="mb-4">
      {cards.map((card, index) => (
        <DashboardCard key={index} title={card.title} links={card.links}
         leadsData={card.title === 'Leads' ? leadsData : null}
         usersData={card.title === 'Users' ? usersData : null} 
         empData={card.title === 'Employees' || card.title === 'Managers' ? empData : null} 
         ticketData={card.title === 'Tickets / Transactions' ? ticketData : null} 
         taskData={card.title === 'Tasks' ? taskData : null} 
         />
      ))}
    </Row>
  );
};

export default Dashboard;
